import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurDate, getDateString } from "../utils/DateTimeUtils";


const initialState = {
    messages: [],
    teleNewMessages: [] ,
}

export const notilSlice = createSlice({
    name: "notilSlice",
    initialState,
    //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
    reducers: {
        updateNotiMessage: (state, action) => {
            const { message } = action.payload
            state.messages.push(message)
        },
        clearMessages: (state, action) => {
            state.messages = []
        }
    },
    extraReducers: (builder) => {

    },
});

export const { updateNotiMessage: updateNotiMessage, clearMessages } = notilSlice.actions;
export default notilSlice.reducer;